import React, { createContext, useContext, useReducer } from 'react';
import { biddingDetailReducer, initialState, IBiddingDetailState, Action } from './bidding-detail-reducer';

const BiddingDetailStateContext = createContext<IBiddingDetailState | undefined>(undefined);
const BiddingDetailDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const BiddingDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(biddingDetailReducer, initialState);

    return (
        <BiddingDetailStateContext.Provider value={state}>
            <BiddingDetailDispatchContext.Provider value={dispatch}>
                {children}
            </BiddingDetailDispatchContext.Provider>
        </BiddingDetailStateContext.Provider>
    );
};

export const useBiddingDetailState = (): IBiddingDetailState => {
    const context = useContext(BiddingDetailStateContext);
    if (!context) {
        throw new Error('useBiddingDetailState must be used within BiddingDetailProvider');
    }
    return context;
};

export const useBiddingDetailDispatch = (): React.Dispatch<Action> => {
    const context = useContext(BiddingDetailDispatchContext);
    if (!context) {
        throw new Error('useBiddingDetailDispatch must be used within BiddingDetailProvider');
    }
    return context;
};
